// extracted by mini-css-extract-plugin
export default {"title":"MovieDetail_title__+aQ0I","font_manager":"MovieDetail_font_manager__gB9bw","poster":"MovieDetail_poster__eGXtZ"};